<template>
	<section class="item">
		<div class="avatar">
			<img :src="avatar_url" alt="">
		</div>
		<div class="name text-truncate">
			<span class="text-truncate">{{ nome }}</span>
		</div>
		<div class="previaText text-truncate">
			<span class="text-truncate">{{ prev_text }}</span>
		</div>
		<div class="time">
			<span> {{ time }}</span>
		</div>
		<div class="notificacao" :class="{temNotify: notify > 0}">
			<div class="count"> <span>{{ notify }}</span></div>
		</div>
	</section>
</template>

<script>
export default {
	name: "ItemTodasMensagens",

	props: [
		'avatar_url',
		'nome',
		'prev_text',
		'time',
		'notify',
	],
}
</script>

<style scoped>
	.item {
		display: grid;
		grid-template-areas:
			"avatar name time"
			"avatar previaText notificacao";
		grid-template-columns: 60px 1fr 40px;
		grid-template-rows: 30px 30px;
	}
	.avatar {
		grid-area: avatar;
		padding: 5px;
		display: grid;
		place-items: center;
	}
	.avatar img {
		width: 50px;
		height: 50px;
		/* border-radius: 50%; */
	}
	.name {
		grid-area: name;
		padding: 5px;
	}
	.name span {
		font-size: 16px;
		font-weight: bold;
	}
	.time {
		grid-area: time;
		text-align: center;
		padding: 5px;
	}
	.time span {
		font-size: 11px;
		color: #b3b1b1;
	}
	.previaText {
		grid-area: previaText;
		padding: 5px;
	}
	.notificacao {
		grid-area: notificacao;
		padding: 5px;
		display: grid;
		place-items: center;
	}
	.notificacao .count {
		display: none;
		border-radius: 2px;
		height: 18px;
		width: 18px;
		place-items: center;
	}
	.notificacao.temNotify .count {
		background: #1aac1a;
		display: grid;
	}
	.notificacao .count span {
		font-size: 11px;
		color: white;
	}
</style>
